import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../../contexts/auth/Context";
import {
  notificationsQueryKey,
  platformNotificationsQueryKey,
} from "../../query/keys";
import { CACHE_TIMES } from "../../query/options";
import { getNotificationsRequest } from "../requests/notification/notification";
import { getPlatformNotificationsRequest } from "../requests/notification/platformNotification";
import { isSuperAdminRole } from "../../contexts/auth/utils";

interface UseNotificationsParams {
  limit?: number;
  offset?: number;
  type?: string;
  unreadOnly?: boolean;
}

export const useNotifications = (params: UseNotificationsParams = {}) => {
  const { token } = useAuth();
  // El SUPERADMIN no tiene gym: lee la bandeja de plataforma en vez de la del gym.
  const isPlatform = isSuperAdminRole(token);

  return useQuery({
    queryKey: isPlatform
      ? platformNotificationsQueryKey(params as Record<string, unknown>)
      : notificationsQueryKey(params as Record<string, unknown>),
    queryFn: () =>
      isPlatform
        ? getPlatformNotificationsRequest(token!, params)
        : getNotificationsRequest(token!, params),
    enabled: !!token,
    ...CACHE_TIMES.TRANSACTIONAL_DATA,
  });
};
